import {lazy} from 'react';


export const DeviceOperationalStatisticLazy = lazy(() => import('./DeviceOperationalStatistic'))